import * as React from "react";
import {
  Navbar,
  Nav,
  Logo,
  NavItem,
  useUser,
  Icon,
  Button,
} from "@literati/dj-react";

export default function Navigation() {
  return (
    <Navbar>
      <Logo />
      <h1
        style={{
          fontSize: "var(--dj-size-font-md)",
          fontWeight: "var(--dj-font-weight-bold)",
        }}
      >
        Returns QA
      </h1>
      <Auth />
    </Navbar>
  );
}

function Auth() {
  const { user, logInUser, logOutUser } = useUser();
  if (!user.is_authenticated) return <div onClick={logInUser}>Login</div>;
  return (
    <div
      onClick={logOutUser}
      style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
    >
      <>{user.email} </>
      <Icon name="x" style={{ width: "20px" }} />
    </div>
  );
}
